export default "__VITE_ASSET__CZPXgqaV__"